import {Component, ElementRef} from '@angular/core';

// Services
import {CartService} from '../../services/cart-service';
import {CatalogService} from '../../services/catalog-service';
import {AppService} from '../../../../shared/services/app-service';
import {GeneratorsService} from '../../services/generators-service';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:PrintSummaryCmp'));

@Component({
    selector: 'print-summary-cmp',
    template: require('./print-summary.cmp.html'),
    styles: [String(require('./print-summary.cmp.scss'))],
    host: { class: 'print-summary' }
})
export class PrintSummaryCmp {

    private _generatorCfg;
    private _roomDimensions;
    private _printSummaryElem;
    private _imgPaths;
    
    constructor(
        private _elementRef: ElementRef,
        private _appService: AppService,
        private _cartService: CartService,
        private _catalogService: CatalogService,
        private _generatorsService: GeneratorsService
    ) {
        // 'Construct print summary component' );

        this._printSummaryElem = _elementRef.nativeElement;

        // Cache generators state
        this._generatorCfg = this._generatorsService.state.generatorCfg;
        this._roomDimensions = this._generatorsService.state.roomDimensions;
        this._imgPaths = this._catalogService.imgPaths;
    }

    private _dic = {
        stone: 'Natural Stone',
        ceramic: 'Ceramic, Porcelain, Glass Tile',
        acrylic: 'Acrylic, Fiberglass, Composite'
    };

    
    private _roundRoomVolume(volume) {
        debugOff( 'Round room volume' );
        return Math.ceil(volume);
    }


    ngOnInit() {
        // 'Initialise print summary component' );
    }

    
    ngOnDestroy() {
        // 'Destroy print summary component' );
    }

    
    private _printDiv() {
        var printContents = this._printSummaryElem.innerHTML;
        var popupWin = window.open('', '_blank', 'width=300,height=300');
        popupWin.document.open();
        popupWin.document.write(
            '<html>' +
            '<head>' +
            '<base href="/">' +
            '<link rel="stylesheet" type="text/css" href="assets/css/print.css" />' +
            '<link href="https://fonts.googleapis.com/css?family=Open+Sans:400,300,600,700" rel="stylesheet" type="text/css">' +
            '</head>' +
            '<body onload="window.print()">' +
            printContents +
            '</html>'
        );
        popupWin.document.close();
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/components/modals/print-summary.cmp.ts